angular.module('impactx.scrollMenu').controller('ScrollMenuCtrl', ['$scope', '$timeout', ScrollMenuCtrl]);

function ScrollMenuCtrl($scope, $timeout) {
    var ctrl = this;

    ctrl.doScroll = function (id) {
        var target,
        topOffset,
        scrollTop,
        topOffsetToUse,
        mainContent;
        

        // Kleine "dirty" Lösung für Angular.
        try {
            mainContent = angular.element('ng-view').find('#main-content');
            topOffset = mainContent.offset();
            scrollTop = mainContent.scrollTop();

            if(topOffset) {
                topOffsetToUse = angular.element("#" + id).offset().top + scrollTop;
                //console.log('Angular way...');
                mainContent.animate({
                    scrollTop: topOffsetToUse - topOffset.top
                }, 350);
                return;
            }
        }catch(e) {}
        
        if (!$scope.scrollArea) {
            target = angular.element('ng-view').find('md-content');
        }
        else {
            target = angular.element($scope.scrollArea);
        }

        var topOffsetToUse = angular.element("#" + id).offset().top + target.scrollTop();
        target.animate({
            scrollTop: topOffsetToUse - target.offset().top
        }, 350);
    };

    ctrl.scrollTo = function (item) {
        if (item.func) {
            
            var time =  0;
            
            if(typeof item.timeout === 'number') {
                time = item.timeout;
            }
            if(typeof item.timeoutFunc === 'function') {
                time = item.timeoutFunc();
            }

            item.func();

            $timeout(function () {
                ctrl.doScroll(item.id)
            }, time);
        }
        else {
            ctrl.doScroll(item.id);
        }
    };

    ctrl.getNumberOfErrors = function (item) {
        var form = item.form;
        var errors = 0;

        for (var key in form.$error) {
            errors += form.$error[key].length;
        }
        if (item.additionalErrors) {
            errors += item.additionalErrors.length;
        }
        return errors;
    }
}